import { cva } from 'class-variance-authority';

export const gapVariants = cva('', {
  variants: {
    size: {
      tiny: 'gap-spacing-comp-button-tiny-gap',
      small: 'gap-spacing-comp-button-small-gap',
      medium: 'gap-spacing-comp-button-medium-gap',
    },
  },
});
